import Marquee from "react-fast-marquee";
import Reveal from "./Reveal";

const partners = [
  "TAITRA",
  "Moscow Tourism Committee",
  "European Higher Education Fair",
  "T-Technologies Group",
];

const Clients = () => {
  return (
    <section id="partners" data-testid="partners-section" className="py-20 sm:py-24 bg-white border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto">
            <p className="text-xs uppercase tracking-widest text-[#D91C29] font-semibold">Trusted collaborations</p>
            <h2 className="font-serif-display text-3xl sm:text-4xl font-bold text-[#0B1B3D] tracking-tight mt-3">
              Partners who trust our expertise
            </h2>
            <p className="mt-4 text-slate-600 leading-relaxed">
              We are proud to have collaborated with respected institutions and organisations
              across borders and sectors.
            </p>
          </div>
        </Reveal>
      </div>

      <div className="mt-12">
        <Marquee gradient gradientColor="#ffffff" gradientWidth={100} speed={40} pauseOnHover>
          {partners.concat(partners).map((p, i) => (
            <div
              key={i}
              data-testid={`partner-${i}`}
              className="mx-12 flex items-center"
            >
              <span className="font-serif-display text-2xl sm:text-3xl font-semibold text-[#0B1B3D]/70 whitespace-nowrap hover:text-[#D91C29] transition-colors">
                {p}
              </span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default Clients;
